/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from 'react';
import UserForm from '../containers/UserForm';
import SuccessForm from '../containers/SuccessForm';
import ErrorForm from '../containers/ErrorForm';
import ProgressForm from '../containers/ProgressForm';
import Jumbotron from './Jumbotron.jsx';

export default class FormsBox extends React.Component {
  renderForm() {
    const { form } = this.props;
    if (form === 'userForm') return <UserForm/>;
    if (form === 'successForm') return <SuccessForm/>;
    if (form === 'errorForm') return <ErrorForm/>;
    if (form === 'progressForm') return <ProgressForm/>;
    return <h3>Nessuna corrispondenza</h3>;
  }

  render() {
    return <div className="row">
    <div className="col-12 mb-5">
    <Jumbotron/>
    </div>
    {this.renderForm()}
    </div>;
  }
}
